import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/checkout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import { T } from "@/constants/testIds";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("db_admin_token", data.token);
      localStorage.setItem("db_admin_email", data.email);
      toast.success("Autenticado");
      nav("/admin/painel");
    } catch (e) {
      toast.error("Credenciais inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-5 grain">
      <form
        onSubmit={submit}
        className="w-full max-w-md border border-white/10 bg-[#0a0a0a] p-8 relative"
      >
        <div className="absolute top-5 right-5 font-mono text-[9px] tracking-[0.3em] text-red-500">
          ÁREA · RESERVADA
        </div>
        <Logo className="h-8 w-8" />
        <h1 className="font-display text-3xl text-neutral-50 mt-10 mb-2">Painel editorial</h1>
        <p className="text-neutral-500 text-[13px] mb-8">Acesso restrito à equipe do dossiê.</p>

        <div className="space-y-5">
          <div>
            <Label className="font-mono text-[10px] tracking-[0.3em] uppercase text-neutral-400">E-mail</Label>
            <Input
              data-testid={T.adminEmail}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="bg-black border-white/10 h-12 mt-2 text-neutral-100"
            />
          </div>
          <div>
            <Label className="font-mono text-[10px] tracking-[0.3em] uppercase text-neutral-400">Senha</Label>
            <Input
              data-testid={T.adminPassword}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="bg-black border-white/10 h-12 mt-2 text-neutral-100"
            />
          </div>
          <Button
            data-testid={T.adminLogin}
            disabled={loading}
            type="submit"
            className="w-full h-12 bg-red-600 hover:bg-red-700 rounded-sm font-mono tracking-[0.25em] text-[11px] uppercase"
          >
            {loading ? "Entrando..." : "Entrar"}
          </Button>
        </div>
      </form>
    </div>
  );
}
